import ServiceReport from "../../Services/ServiceReport";
import {
	ISummaryPort,
	SummaryProducer,
	IError,
	Producer,
	ShipmentSummary,
} from "../../Models/Report";
import { ActionsReport } from "./Types";

const service = new ServiceReport();

export const createActionRequest = () => ({
	type: ActionsReport.REQUEST_REPORT_DASHBOARD
});

export const createActionSetProducers = (producers: Producer[]) => ({
	type: ActionsReport.SET_PRODUCERS,
	payload: producers
});

export const createActionFetchPort = (id: number, idProducer: string) => {
	return (dispatch: any) => {
		service
			.fetchPort(id, idProducer)
			.then(async r => {
				const data: ISummaryPort[] | IError[] = await r.json();
				let summary: SummaryProducer | undefined;
				if ("Status" in data[0]) {
					summary = new SummaryProducer();
					summary.idProducer = idProducer;
				} else {
					summary = SummaryProducer.transform(data as ISummaryPort[]);
					summary.idProducer = idProducer;
				}
				dispatch({ type: ActionsReport.SET_SUMMARY, payload: summary });
			})
			.catch(r => {
				const summary = new SummaryProducer();
				summary.idProducer = idProducer;
				dispatch({ type: ActionsReport.SET_SUMMARY, payload: summary });
			});
	};
};

export enum EReport {
	Announced,
	Summary,
	Stacking,
	Consolidate,
	BreakBulk,
	Bath,
	Yard
}


export const createActionReportData = (fetch: Promise<Response>) => {
	return (dispatch: any) => {
		dispatch({
			type: ActionsReport.REQUEST_ANNOUNCED
		});
		fetch
			.then(async r => {
				const data = await r.json();
				const res = SummaryProducer.transform(data);
				dispatch({
					type: ActionsReport.FETCH_ANNOUNCED_LOAD,
					payload: res
				});
				dispatch({
					type: ActionsReport.REQUEST_ANNOUNCED
				});
			})
			.catch(e => {});
	};
};

export const createActionFetchSummary = (id: number, idProducer: string, idBranch: number) => {
	return (dispatch: any) => {
		service
			.fetchSummary(id, idProducer, idBranch)
			.then(async r => {
				const data = await r.json();
				const res = ShipmentSummary.create(data);
				dispatch({
					type: ActionsReport.FETCH_SHIPMENT,
					payload: res
				});

			})
			.catch(e => {});
	};
};

export const createActionClearData = (report: EReport) => {
	return (dispatch: any) => {
		switch (report) {
			case EReport.Announced:
				dispatch({
					type: ActionsReport.FETCH_ANNOUNCED_LOAD,
					payload: undefined
				});
				break;
			case EReport.Summary:
					dispatch({
						type: ActionsReport.FETCH_SHIPMENT,
						payload: undefined
					});
					break;
		}
	};
};

export const createActionsRequestShipment = {
	type: ActionsReport.REQUEST_SHIPMENT
}

export const createActionSetBranch = (
	id: number,
	idProducer: string,
	idBranch: number
) => {
	return (dispatch: any) => {
		dispatch(createActionClearData(EReport.Summary));
		dispatch(createActionsRequestShipment);
		dispatch(createActionFetchSummary(id, idProducer, idBranch));
		dispatch(createActionsRequestShipment);
	}
}

export const createActionSetProducer = (
	id: number,
	idProducer: string,
	report: EReport
) => {
	return (dispatch: any) => {
		switch (report) {
			case EReport.Announced:
				return dispatch(createActionReportData(service.fetchAnnounced(id, idProducer)));
			case EReport.Stacking:
				return dispatch(createActionReportData(service.fetchStacking(id, idProducer)));
			case EReport.Consolidate:
				return dispatch(createActionReportData(service.fetchConsolidate(id, idProducer)));
			case EReport.BreakBulk:
				return dispatch(createActionReportData(service.fetchBreakBulk(id, idProducer)));
			case EReport.Yard:
				return dispatch(createActionReportData(service.fetchYard(id, idProducer)));
			case EReport.Bath:
					return dispatch(createActionReportData(service.fetchBath(id, idProducer)));
			case EReport.Summary:
		}
	};
};
